import { useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { useAFBCustomerTable } from './hooks/useAFBCustomerTable';
import { customStylesCompany } from '../../../util/TableStyles';
import { noDataComponent } from '../../../util/DataObject';
import { FlexGrid, Typography, useThemeProvider, Card, Skeleton, Link } from '@albo-ui/core';
import { AfbCompanyCards, AfbAccountNumbers, AfbClabeCreate } from '../../modals';
import { CreditCard, Construction } from "@mui/icons-material";
import CustomPagination from '../../elements/CustomPagination';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';

export const AfbCustomerList = ({ changeAlert, changeLoader, changeWidgets, addWidget }: any) => {    
    const { data, item, columns, config, loading: loadingTable, pagination, dialogAccount, dialogCards, dialogClabe,
            getData, changePage, handleChangeRowsPerPage, onOpenDialogAccount, onOpenDialogClabe, onCloseDialog } = useAFBCustomerTable(changeAlert, changeWidgets, addWidget)
    const { theme } = useThemeProvider();

    const hasAction = (action) => {
        return config?.actions?.indexOf(action) > -1;
    };

    useEffect(() => {
        getData(1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        changeLoader(loadingTable)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingTable]);
      
    return (
        <>
        { loadingTable ? 
            <Skeleton width='100%' height='100px' />
            :
            <FlexGrid container spacing={2} fullWidth>
                <Card padding={2} flexDirection="column" fullWidth fullHeight alignItems="stretch" justifyContent="space-between" style={{borderColor: "#EDF0F4", paddingInline: 32}}> 
                    <Typography variant="h2" style={{display: "inline-flex", alignItems: "center", fontSize: "1.2rem"}}>
                        <Construction sx={{ marginRight: 1 }}/> IT tools
                    </Typography>
                </Card>
                <Card padding={2} flexDirection="column" fullWidth fullHeight alignItems="stretch" justifyContent="space-between" style={{borderColor: "#EDF0F4", paddingInline: 32}}> 
                    <Typography variant="h2" style={{display: "inline-flex", alignItems: "center", fontSize: "1.2rem"}}>
                        <Link onClick={onOpenDialogAccount} bold style={{ display: "flex", alignItems: "center" }} typography="smallTitle">
                        <CreditCard style={{ marginRight: 8}} /> Solicitar números de cuenta
                        </Link>
                    </Typography>
                </Card>
                {hasAction("afbClabeCreate") && <Card padding={2} flexDirection="column" fullWidth fullHeight alignItems="stretch" justifyContent="space-between" style={{borderColor: "#EDF0F4", paddingInline: 32}}> 
                    <Typography variant="h2" style={{display: "inline-flex", alignItems: "center", fontSize: "1.2rem"}}>
                        <Link onClick={onOpenDialogClabe} bold style={{ display: "flex", alignItems: "center" }} typography="smallTitle">
                        <AccountBalanceWalletIcon style={{ marginRight: 8}} /> Creación de CLABE albo
                        </Link>
                    </Typography>
                </Card>}
            </FlexGrid>
        }

            <Card padding={4} flexDirection='column' fullWidth fullHeight alignItems='stretch' justifyContent='space-between' style={{ borderColor: theme.colors.manatee, marginTop: 16 }}> 
                <FlexGrid container fullWidth justify='space-between'>
                    {loadingTable ? 
                        <Skeleton width='100%' height='100px' style={{marginTop: 20}} />
                        :
                        <>
                        <FlexGrid item >
                            <Typography variant='h2' style={{display: 'flex', alignItems: 'center', fontSize: '1.2rem'}}>
                                <AccountBalanceIcon sx={{ marginRight: 1 }}/> Empresas
                            </Typography>
                        </FlexGrid>
                        <CustomPagination 
                            rows={pagination.totalDocuments}
                            page={pagination.page - 1}
                            rowsPerPage={pagination.rowsPerPage}
                            handleChangePage={changePage}
                            handleChangeRowsPerPage={handleChangeRowsPerPage}
                        />
                        </>
                    }
                </FlexGrid>

                <FlexGrid container style={{margin: '25px 0' }} direction='column'>
                    {
                        loadingTable ?
                            <Skeleton width='100%' height='100px' />
                            :
                            <>
                            <DataTable
                                columns={columns}
                                data={data}
                                customStyles={customStylesCompany}
                                noDataComponent={noDataComponent}
                            />
                            </>
                    }
                </FlexGrid>
            </Card>

            <AfbCompanyCards
                open={dialogCards.open}
                content={item}
                onClose={onCloseDialog}
            />

            <AfbAccountNumbers
                open={dialogAccount.open}
                onClose={onCloseDialog}
                changeAlert={changeAlert}
                changeLoader={changeLoader}
            />

            <AfbClabeCreate
                open={dialogClabe.open}
                onClose={onCloseDialog}
                changeAlert={changeAlert}
                changeLoader={changeLoader}
            />
        </>
    )
};